export default __webpack_public_path__ + "static/media/petro.da49288c.jpg";